(function() {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'SbKUWL';
  var KLAVIYO_NEWSLETTER_LIST_ID = 'YmUnPY';
  var KLAVIYO_REVISION = '2024-10-15';
  var STOREFRONT_API_VERSION = '2025-01';
  var SWATCH_PRODUCT_ID = 10443674517851;

  // Country name → ISO 3166-1 alpha-2 (matches the <select> options)
  var COUNTRY_CODES = {
    'United Kingdom': 'GB', 'Ireland': 'IE', 'France': 'FR',
    'Germany': 'DE', 'Netherlands': 'NL', 'Belgium': 'BE',
    'Italy': 'IT', 'Spain': 'ES', 'Denmark': 'DK',
    'Sweden': 'SE', 'Norway': 'NO', 'United States': 'US',
    'Canada': 'CA', 'Australia': 'AU', 'Japan': 'JP',
    'Nigeria': 'NG', 'Ghana': 'GH', 'South Africa': 'ZA',
    'United Arab Emirates': 'AE'
  };

  // ---- URL params ----
  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('product');
  var variantId = params.get('variant');
  var productColour = decodeURIComponent(params.get('colour') || '');
  var productTitle = '';

  // ---- DOM refs ----
  var wrapper = document.getElementById('claim-swatch-wrapper');
  var fallback = document.getElementById('claim-swatch-fallback');
  var form = document.getElementById('claim-swatch-form');
  var submitBtn = document.getElementById('claim-swatch-submit');
  var submitLabel = submitBtn ? submitBtn.querySelector('span') : null;
  var generalError = document.getElementById('claim-swatch-general-error');

  // ---- Guard: missing params ----
  if (!productHandle || !variantId) {
    if (wrapper) wrapper.style.display = 'none';
    if (fallback) fallback.style.display = 'block';
    return;
  }

  // ---- Fetch product title for context ----
  fetch('/products/' + encodeURIComponent(productHandle) + '.js')
    .then(function(res) { return res.json(); })
    .then(function(data) {
      productTitle = data.title || '';
    })
    .catch(function() { /* non-critical */ });

  // ---- Helpers ----
  function getVal(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function showErrors(errors) {
    var errorEls = form.querySelectorAll('.claim-swatch-form__error');
    for (var i = 0; i < errorEls.length; i++) {
      errorEls[i].textContent = '';
      errorEls[i].style.display = 'none';
    }
    for (var key in errors) {
      var el = form.querySelector('[data-error-for="' + key + '"]');
      if (el) {
        el.textContent = errors[key];
        el.style.display = 'block';
      }
    }
  }

  function showGeneralError() {
    if (generalError) generalError.style.display = 'block';
  }

  function hideGeneralError() {
    if (generalError) generalError.style.display = 'none';
  }

  function klaviyoPost(endpoint, payload) {
    return fetch('https://a.klaviyo.com' + endpoint + '?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function(res) {
      if (!res.ok) throw new Error('Klaviyo ' + endpoint + ' responded ' + res.status);
      return res;
    });
  }

  // ---- Validation ----
  function validate() {
    var errors = {};
    var email = getVal('claim-swatch-email');
    var firstName = getVal('claim-swatch-first-name');
    var lastName = getVal('claim-swatch-last-name');
    var address1 = getVal('claim-swatch-address1');
    var city = getVal('claim-swatch-city');
    var postcode = getVal('claim-swatch-postcode');
    var country = getVal('claim-swatch-country');
    var bdayDay = getVal('claim-swatch-bday-day');
    var bdayMonth = getVal('claim-swatch-bday-month');
    var bdayYear = getVal('claim-swatch-bday-year');

    if (!email) errors.email = 'Email is required.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = 'Please enter a valid email.';

    if (!firstName) errors.first_name = 'First name is required.';
    if (!lastName) errors.last_name = 'Last name is required.';
    if (!address1) errors.address1 = 'Address is required.';
    if (!city) errors.city = 'City is required.';

    if (!postcode) {
      errors.postcode = 'Postcode is required.';
    } else if (country === 'United Kingdom' && !/^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(postcode)) {
      errors.postcode = 'Please enter a valid UK postcode.';
    }

    if (!bdayDay || !bdayMonth || !bdayYear) errors.birthday = 'Birthday is required.';

    return errors;
  }

  // ---- Submit handler ----
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Honeypot
    // Honeypot: a bot filled the hidden field. Show the normal 'Sending' state so it cannot tell it was caught; send nothing.
    if (document.getElementById('website-hp').value !== '') {
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Sending\u2026';
      return;
    }

    var errors = validate();
    if (Object.keys(errors).length > 0) {
      showErrors(errors);
      return;
    }

    showErrors({});
    hideGeneralError();

    // Disable button
    submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Sending\u2026';

    // Collect values
    var email = getVal('claim-swatch-email');
    var firstName = getVal('claim-swatch-first-name');
    var lastName = getVal('claim-swatch-last-name');
    var address1 = getVal('claim-swatch-address1');
    var address2 = getVal('claim-swatch-address2');
    var city = getVal('claim-swatch-city');
    var postcode = getVal('claim-swatch-postcode');
    var country = getVal('claim-swatch-country');
    var bdayDay = getVal('claim-swatch-bday-day');
    var bdayMonth = getVal('claim-swatch-bday-month');
    var bdayYear = getVal('claim-swatch-bday-year');
    var consent = document.getElementById('claim-swatch-consent').checked;

    // Format birthday YYYY-MM-DD
    var birthday = bdayYear + '-' + String(bdayMonth).padStart(2, '0') + '-' + String(bdayDay).padStart(2, '0');

    // ---- Step 1: Klaviyo profile (fail-open) ----
    var profilePayload = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          first_name: firstName,
          last_name: lastName,
          location: {
            address1: address1,
            address2: address2,
            city: city,
            country: country,
            zip: postcode
          },
          properties: {
            birthday: birthday,
            birthday_set: true,
            swatch_requested: true,
            last_swatch_product: productTitle,
            last_swatch_colour: productColour,
            swatch_source: 'Feel It landing page'
          }
        }
      }
    };

    klaviyoPost('/client/profiles/', profilePayload)
      .catch(function(err) { console.warn('Profile create failed (non-blocking):', err); })
      .then(function() {
        // ---- Step 2: Subscribe if consent (fail-open) ----
        // Uses application/vnd.api+json (JSON:API) — required by /client/subscriptions/
        if (consent) {
          return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              'revision': KLAVIYO_REVISION
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Feel It landing page',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email
                      }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: KLAVIYO_NEWSLETTER_LIST_ID
                    }
                  }
                }
              }
            })
          }).catch(function(err) { console.warn('Subscription failed (non-blocking):', err); });
        }
      })
      .then(function() {
        // ---- Step 3: Remove any stale swatch from main basket (fail-open) ----
        return fetch('/cart.js').then(function(res) { return res.json(); }).then(function(cart) {
          var swatchLines = (cart.items || []).filter(function(item) {
            return item.product_id === SWATCH_PRODUCT_ID;
          });
          if (swatchLines.length === 0) return;
          // Remove each swatch line by setting quantity to 0
          var updates = {};
          swatchLines.forEach(function(item) { updates[item.key] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }).catch(function(err) { console.warn('Swatch cleanup failed (non-blocking):', err); });
      })
      .then(function() {
        // ---- Step 4: Create isolated swatch checkout via Storefront API ----
        var gid = 'gid://shopify/ProductVariant/' + variantId;
        var countryCode = COUNTRY_CODES[country] || 'GB';
        var mutation = 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }';
        var variables = {
          input: {
            lines: [{ merchandiseId: gid, quantity: 1 }],
            attributes: [
              { key: 'birthday', value: birthday },
              { key: 'swatch_requested', value: 'true' }
            ],
            buyerIdentity: {
              email: email,
              deliveryAddressPreferences: [{
                deliveryAddress: {
                  firstName: firstName,
                  lastName: lastName,
                  address1: address1,
                  address2: address2 || undefined,
                  city: city,
                  zip: postcode,
                  country: countryCode
                }
              }]
            }
          }
        };

        return fetch('/api/' + STOREFRONT_API_VERSION + '/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: mutation, variables: variables })
        }).then(function(res) {
          if (!res.ok) throw new Error('Storefront API responded ' + res.status);
          return res.json();
        }).then(function(json) {
          if (json.errors && json.errors.length > 0) {
            throw new Error('GraphQL error: ' + json.errors[0].message);
          }
          var data = json.data && json.data.cartCreate;
          if (!data) throw new Error('Unexpected Storefront API response');
          if (data.userErrors && data.userErrors.length > 0) {
            throw new Error('Cart error: ' + data.userErrors[0].message);
          }
          var checkoutUrl = data.cart && data.cart.checkoutUrl;
          if (!checkoutUrl) throw new Error('No checkout URL returned');
          return checkoutUrl;
        });
      })
      .then(function(checkoutUrl) {
        // ---- Step 5: Redirect to swatch checkout ----
        console.log('Swatch checkout URL:', checkoutUrl);
        window.location.href = checkoutUrl;
      })
      .catch(function(err) {
        // Swatch checkout failure — let user retry
        console.error('Checkout error:', err);
        submitBtn.disabled = false;
        if (submitLabel) submitLabel.textContent = 'Send my swatch';
        showGeneralError();
      });
  });
})();
